<template>
  <a @click="showModal = true" target="_blank" class="plain-link flex shadow-sm rounded-md cursor-pointer">
    <div
      class="shrink-0 flex items-center justify-center w-10 md:w-16 text-white text-sm
                                bg-blue-500 leading-5 font-medium rounded-l-md">
      <span v-if="creatingAlarm === false" class="lnr text-white icon-alarm-check"></span>
      <span v-else class="lnr icon-loading animate-spin"></span>
    </div>
    <div class="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate">
      <div class="flex-1 px-4 py-4 text-sm leading-5 truncate">
        <span class="text-gray-900 font-medium hover:text-gray-600">
          Create Validation Alarm
        </span>
      </div>
      <div class="shrink-0 pr-2">
        <button
          class="w-8 h-8 inline-flex items-center justify-center text-gray-400 rounded-full bg-transparent hover:text-gray-500 focus:outline-none focus:text-gray-500 focus:bg-gray-100">
          <span class="lnr icon-arrow-right"></span>
        </button>
      </div>
    </div>

    <notification-modal
      v-model:is-open="showModal"
      :is-error-modal="true"
      :give-option="true"
      v-on:primary-action="sendAlarm"
    >
      <template #title-content>
        Are you sure you want to create a validation alarm?
      </template>
      {{ modalText }}
      <p class="text-sm text-gray-600 mt-2">
        Adding a reading value is optional and may be required for certain regulatory
        validations such as AABB. Any value inserted will be stored in the database
        and will appear on reports like the Excursion Report.
      </p>
      <div class="flex items-center mt-4">
        <toggle v-model:value="insertValue"></toggle>
        <span class="ml-2 text-sm">Insert reading into database</span>
      </div>
      <div class="mt-4" v-if="insertValue">
        <floating-input v-model:value="readingValue" label="Reading Value"></floating-input>
      </div>
      <template #button-primary-content>
        Create Alarm
      </template>
    </notification-modal>
  </a>
</template>

<script>
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import axios from "axios";
import FloatingInput from "@/components/elements/FloatingInput";
import Toggle from "@/components/elements/toggle";

export default {
  name: "MeterValidationAlarm",
  mixins: [SonicuCoreMixin],
  components: {FloatingInput, Toggle},
  props: {
    meter: {
      type: Object,
      required: true
    },
  },
  data(){
    return {
      showModal: false,
      users: {},
      creatingAlarm: false,
      readingValue: '',
      insertValue: false,
    }
  },
  mounted() {
    this.loadData();
  },
  computed: {
    usersCount(){
      return Object.entries(this.users).length;
    },
    userNotificationMethodsCount(){
      let count = 0;
      for(const[key, value] of Object.entries(this.users)){
        count += value.email;
        count += value.sms;
        count += value.voice;
        count += value.push;
      }
      return count;
    },
    modalText(){
      return "This will notify " + this.usersCount + " users with " + this.userNotificationMethodsCount + " notification methods. Are you sure you want to continue?";
    }
  },
  methods: {
    sendAlarm(){
      this.creatingAlarm = true;
      axios.patch(this.company.buildCompanyApiInternalRoute('alarms/validation/' + this.meter.ID), {
        value: this.insertValue ? this.readingValue : null
      }).then(
        response => {
          console.log(response.data);
          window.location = this.company.buildCompanyRoute('alarms/' + response.data.AlarmID);
        }
      ).catch(
        error => {

        }
      )
    },

    loadData(){
      axios.get(this.company.buildCompanyApiInternalRoute('zones/' + this.meter.ZoneID + '/alarm-notification-methods')).then(
        response => {
          this.users = response.data;
          this.loading = false
        }
      ).catch(
        error => {

        }
      )
    },
  }
}
</script>

<style scoped>

</style>